import { LeadsDateRangeInteface } from "../interfaces/leads-fila.interface";

/**
 * Utilitário para manipulação de datas no formato local (GMT-3)
 * Evita conversões indesejadas de timezone ao serializar datas para APIs
 */
export class DateUtil {

  /**
   * Converte um objeto Date para string ISO no timezone local (sem conversão UTC)
   * Útil para enviar datas ao backend que espera horário de Brasília (GMT-3)
   *
   * Exemplo:
   * - Entrada: new Date(2024, 0, 15, 15, 30, 0) // 15:30 GMT-3
   * - Saída: "2024-01-15T15:30:00" (mantém horário local)
   *
   * @param date - Objeto Date a ser convertido
   * @returns String no formato ISO (YYYY-MM-DDTHH:mm:ss) ou null se date for null/undefined
   */
  static convertDateToLocalISOString(date: Date | null | undefined): string | null {
    if (!date) {
      return null;
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }



  static parseDate(dateString: string): Date | undefined {
    if (!dateString || dateString.trim() === '') {
      return undefined;
    }

    if (dateString.includes('/')) {
      const [day, month, year] = dateString.split('/');
      return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    }
    if (dateString.includes('-')) {
      return new Date(dateString);
    }

    return undefined;
  }


  static formatDateForInput(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }



  static getDateRange(intervalMonths:number): LeadsDateRangeInteface {
    const today = new Date();
    const initialDate = new Date();
    initialDate.setMonth(today.getMonth() - intervalMonths);

    return {
      start: DateUtil.formatDateForInput(initialDate),
      end: DateUtil.formatDateForInput(today)
    };
  }



}

